import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import Inr from '@/components/Inr/index.vue';
import DispatchList from '@/views/orders-dispatches/components/DispatchList.vue';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.listLoading = false;
    this.list = [];
    this.tableKey = 0;
    this.expandedRowKeys = [];
  }
  activated() {}
  toggleExpand(row) {
    if (this.expandedRowKeys.indexOf(row.id) === -1) {
      this.expandedRowKeys = [row.id];
    } else {
      this.expandedRowKeys = [];
    }
  }
};
__decorate([Prop({
  default: []
})], default_1.prototype, "data", void 0);
default_1 = __decorate([Component({
  name: 'OrderDispatchTab',
  components: {
    Inr,
    DispatchList
  }
})], default_1);
export default default_1;